module.exports = __webpack_public_path__ + "images/google-permissions-5048d42b58cc353331606b7d15f4788d.jpg";